module.exports = __webpack_public_path__ + "images/prev.png";


//////////////////
// WEBPACK FOOTER
// ./~/lightbox2/dist/images/prev.png
// module id = 183
// module chunks = 0